import enviro from 'enviro';
export let ENV;
(function (ENV) {
  ENV["PROD"] = "PROD";
  ENV["QA"] = "QA";
})(ENV || (ENV = {}));
export const CURRENT_ENV = enviro.isQa() ? ENV.QA : ENV.PROD;